<template>
  <div class="student-tag-item" v-bitmap="getListResult">
    <studentTagList
      :studentTagList="studentTagData"
      class="student-tag-list-content-main"
      :editShow="editShow"
      @reviseShowType="reviseShowType"
      @reviseTag="reviseTag"
      @delTag="delTag"
      :checkAll="checkAll"
      @deleteBatchList="deleteBatchList"
      @tagBindStudentListDialogShow="tagBindStudentListDialogShow"
    />
    <!-- <pagination
      :pageSize="pageSize"
      :total="total"
      @currentPageNumChange="currentPageNumChange"
    ></pagination> -->
  </div>
</template>

<script>
import studentTagList from "../student-tag-list/student-tag-list.vue";

export default {
  data() {
    return {};
  },
  components: {
    studentTagList,
  },
  created() {},
  props: {
    studentTagData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    getListResult: {
      type: String,
    },
    // pageSize: {
    //   type: Number,
    // },
    // total: {
    //   type: Number,
    // },
    editShow: {
      type: String,
    },
    checkAll: {
      type: Boolean,
    },
  },
  methods: {
    // // 分页
    // currentPageNumChange(e) {
    //   this.$emit("pageNum", e);
    // },
    reviseShowType(e) {
      this.$emit("reviseShowType", e);
    },
    reviseTag(e) {
      this.$emit("reviseTag", e);
    },
    delTag(e) {
      this.$emit("delTag", e);
    },
    // 批量删除数据
    deleteBatchList(e) {
      this.$emit("deleteBatchList", e);
    },
    // 点击标签展示绑定学生列表
    tagBindStudentListDialogShow(e) {
      this.$emit("tagBindStudentListDialogShow", e);
    },
  },
};
</script>

<style lang="sass" scoped>
@import "./student-tag-item.scss"
</style>